<label class="mui-switch">
  <input
    type="checkbox"
    [id]="inputId"
    (change)="onChange($event)"
    [checked]="checked"
    [disabled]="disabled"
    [attr.name]="name"
    [class.label-after]="labelPosition === 'after'"
    [required]="required"/>
  <span class="mui-switch__label">
    <ng-content></ng-content>
  </span>
</label>
